export enum KroUploadCardType {
  SMALL,
  LARGE,
}
